const IO_PRODUCTS = {
  'SWITCHER_ONE_BUTTON': 1,
  'SWITCHER_TWO_BUTTON': 2,
  'LINKER': 3,
  'CHECKER': 4
}

const IO_PRODUCTS_NAME = {
  'SWITCHER_ONE_BUTTON': '스위처 1구',
  'SWITCHER_TWO_BUTTON': '스위처 2구',
  'LINKER': '링커',
  'CHECKER': '체커'
}

function convertProductNameFrom (id) {
  switch (id) {
    case IO_PRODUCTS.SWITCHER_ONE_BUTTON:
      return '스위처 1구'
    case IO_PRODUCTS.SWITCHER_TWO_BUTTON:
      return '스위처 2구'
    case IO_PRODUCTS.LINKER:
      return '링커'
    case IO_PRODUCTS.CHECKER:
      return '체커'
  }
}

function convertProductIdFromName (name) {
  switch (name) {
    case IO_PRODUCTS_NAME.SWITCHER:
      return IO_PRODUCTS.SWITCHER_ONE_BUTTON
    case IO_PRODUCTS_NAME.LINKER:
      return IO_PRODUCTS.LINKER
    case IO_PRODUCTS_NAME.CHECKER:
      return IO_PRODUCTS.CHECKER
  }
}
export { IO_PRODUCTS, IO_PRODUCTS_NAME, convertProductNameFrom, convertProductIdFromName }



// WEBPACK FOOTER //
// ./src/modules/products.js